import React, { useState,useEffect } from 'react';
import TrashIcon from '@rsuite/icons/Trash';
import ImageIcon from '@rsuite/icons/Image';
import EditIcon from '@rsuite/icons/Edit';

import {
    Input,
    InputGroup,
    IconButton,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Col,
    Form,
    FlexboxGrid,
    Container,
    SelectPicker,
    useToaster,
    Uploader,
    Message,
    Loader,
    Table,
    Button,
} from 'rsuite';

const data2 = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    item => ({ label: item, value: item })
  );


function previewFile(file, callback) {
    const reader = new FileReader();
    reader.onloadend = () => {
        callback(reader.result);
    };
    reader.readAsDataURL(file);
}

const CompanyMaster = () => {
    const toaster = useToaster();
    const [uploading, setUploading] = React.useState(false);
    const [fileInfo, setFileInfo] = React.useState(null);

    // Api add data start
    const [data, setData] = useState({
        cmpnm: "",
        address: " ",
        country: "",
        state: "",
        city: "",
        pin_no: "",
        reg_type: "",
        org_type: "0",
        faxno: "0",
        email_id: "0",
        website: "",
        gstno: "",
        cmpcd: "CMP1",
        madeby: "Shantanu",
        Bank_Detail: [
          {
            bankName: '',
            branchName: '',
            ifsc_code: '',
            accountno: '',
            bankaddress: '',
            swiftcode: ''
          }
        ],
        Logo: null,
      });

    const url = "http://192.168.1.83:1337/api/company-details"
    const submit = e => {
        if (data.cmpnm=='') {
            toaster2.push(message2, { placement })
            
        }else{
    e.preventDefault();
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    formData.append('files.Logo', data.Logo);
    
    
    fetch(url, {
      method: 'POST',
      body: formData,
    })
      .then(response => fetchData())
      .then(data => console.log(data))
      .catch(error => console.error(error))
      setData({
        cmpnm: "",
        address: " ",
        country: "",
        state: "",
        city: "",
        pin_no: "",
        reg_type: "",
        org_type: "0",
        faxno: "0",
        email_id: "0",
        website: "",
        gstno: "",
        cmpcd: "CMP1",
        madeby: "Shantanu",
        Bank_Detail: [
          {
            bankName: '',
            branchName: '',
            ifsc_code: '',
            accountno: '',
            bankaddress: '',
            swiftcode: ''
          }
        ],
        Logo: null,
      });
      
      toaster1.push(message1, { placement })
    }
      
  };

  const handleInputChange = (inputName, value, index) => {
    if (inputName === 'Bank_Detail') {
      setData(prevData => {
        const updatedBank_Detail = [...prevData.Bank_Detail];
        updatedBank_Detail[index] = {
          ...updatedBank_Detail[index],
          [value.name]: value.value
        };
        return {
          ...prevData,
          Bank_Detail: updatedBank_Detail
        };
      });
    } else {
      setData({ ...data, [inputName]: value });
    }
  };

  const handleImageUpload = fileList => {
    setData({
      ...data,
      Logo: fileList[0].blobFile
    });
  };
  // POST Data from API End

    // Fetch Data from API Start
    const [data1, setData1] = React.useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await fetch('http://192.168.1.83:1337/api/company-details?populate=*');
        const json = await response.json();
        setData1(json.data);
    };
    //  Fetch Data from API End


    // Delete Data from API Start
    const handleDeleteRow = async (rowId) => {
        try {
            const response = await fetch(`http://192.168.1.83:1337/api/company-details/${rowId}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                // Row deletion was successful, update your local data or refresh the table
                const updatedData1 = data1.filter((row) => row.id !== rowId);
                setData1(updatedData1);
                console.log('Row deleted successfully.');
            } else {
                console.log('Failed to delete row.');
            }
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    };
    // Fetch Data from API End

    // for Massage after sumbit form
    const [placement, setPlacement] = React.useState('topCenter');
    const toaster1 = useToaster();

    const message1 = (
        <Message showIcon type='success' closable>
          Company Details Saved Successfully.
        </Message>
      );
      
    const toaster2 = useToaster();

    const message2 = (
        <Message showIcon type='error'>
          Please fill the company details.
        </Message>
      );

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar " justifyContent="space-between">
                    <Stack.Item alignSelf="flex-start">
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Company</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                                <Breadcrumb.Item active>Company</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                    </Stack.Item>
                </Stack>
                <Divider className='divide' />
                <Message type="success" ><b>Company Details </b></Message>
                <Panel>
                    <FlexboxGrid justify="space-between">
                        <FlexboxGrid.Item as={Col} colspan={24} md={16}>
                            <FlexboxGrid justify="space-between">
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                                    <Form.ControlLabel>Company Name</Form.ControlLabel>
                                    <Input 
                                    id="cmpnm"
                                    name="cmpnm"
                                    value={data && data.cmpnm ? data.cmpnm : ''} onChange={value => handleInputChange('cmpnm', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                    <Form.ControlLabel>Address</Form.ControlLabel>
                                    <Input 
                                    id="address"
                                    name="address"
                                    value={data && data.address ? data.address : ''} onChange={value => handleInputChange('address', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Country</Form.ControlLabel>
                                    <SelectPicker id="country"
                                    name="country"
                                    value={data && data.country ? data.country : ''} onChange={value => handleInputChange('country', value)}
                                    data={data2} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                                    <Form.ControlLabel>State</Form.ControlLabel>
                                    <SelectPicker 
                                    id="state"
                                    name="state"
                                    value={data && data.state ? data.state : ''} onChange={value => handleInputChange('state', value)}
                                    data={data2} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>City</Form.ControlLabel>
                                    <SelectPicker 
                                    id="city"
                                    name="city"
                                    value={data && data.city ? data.city : ''} onChange={value => handleInputChange('city', value)}
                                    data={data2} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>PIN No.</Form.ControlLabel>
                                    <Input 
                                    id="pin_no"
                                    name="pin_no"
                                    value={data && data.pin_no ? data.pin_no : ''} onChange={value => handleInputChange('pin_no', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }} >
                                    <Form.ControlLabel>Registration Type</Form.ControlLabel>
                                    <SelectPicker 
                                    id="reg_type"
                                    name="reg_type"
                                    value={data && data.reg_type ? data.reg_type : ''} onChange={value => handleInputChange('reg_type', value)}
                                    data={data2} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Organisation Type</Form.ControlLabel>
                                    <SelectPicker 
                                    id="org_type"
                                    name="org_type"
                                    value={data && data.org_type ? data.org_type : ''} onChange={value => handleInputChange('org_type', value)}
                                    data={data2} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Fax No.</Form.ControlLabel>
                                    <Input 
                                    id="faxno"
                                    name="faxno"
                                    value={data && data.faxno ? data.faxno : ''} onChange={value => handleInputChange('faxno', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }} >
                                    <Form.ControlLabel>Email</Form.ControlLabel>
                                    <Input 
                                    id="email_id"
                                    name="email_id"
                                    value={data && data.email_id ? data.email_id : ''} onChange={value => handleInputChange('email_id', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Website</Form.ControlLabel>
                                    <Input 
                                    id="website"
                                    name="website"
                                    value={data && data.website ? data.website : ''} onChange={value => handleInputChange('website', value)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>GST No.</Form.ControlLabel>
                                    <Input 
                                    id="gstno"
                                    name="gstno"
                                    value={data && data.gstno ? data.gstno : ''} onChange={value => handleInputChange('gstno', value)}
                                    />
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Stack justifyContent='center'>
                            <Uploader
                onChange={handleImageUpload}
                fileListVisible={false}
                listType="picture"
                action={""}
                onUpload={file => {
                  setUploading(true);
                  previewFile(file.blobFile, value => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded successfully</Message>);
                  console.log(response);
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded successfully</Message>);
                }}
              >
                <button style={{ width: 232, height: 196 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img src={fileInfo} width="100%" height="100%" />
                  ) : (
                    <ImageIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>
                            </Stack>
                            <Stack justifyContent='center'>
                                <IconButton size="md" icon={<TrashIcon />} onClick={() => setFileInfo(null)} active />
                            </Stack>


                        </FlexboxGrid.Item>

                    </FlexboxGrid>

                </Panel>
                <Message type="success" ><b>Bank Details</b></Message>
                <Panel>
                    <FlexboxGrid justify='start'>
                    {data.Bank_Detail.map((material, index) => (
                            <div key={index}>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '10px' }}>
                            <Form.ControlLabel>Bank Name</Form.ControlLabel>
                            <Input 
                            name="bankName"
                            value={material.bankName}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'bankName', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Form.ControlLabel>Branch Name</Form.ControlLabel>
                            <Input 
                            name="branchName"
                            value={material.branchName}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'branchName', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                            <Form.ControlLabel>IFSC Code</Form.ControlLabel>
                            <Input 
                            name="ifsc_code"
                            value={material.ifsc_code}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'ifsc_code', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                            <Form.ControlLabel>Account No.</Form.ControlLabel>
                            <Input 
                            name="accountno"
                            value={material.accountno}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'accountno', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                       
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                            <Form.ControlLabel>Address</Form.ControlLabel>
                            <Input 
                            name="bankaddress"
                            value={material.bankaddress}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'bankaddress', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                            <Form.ControlLabel>Swift Code</Form.ControlLabel>
                            <Input 
                            name="swiftcode"
                            value={material.swiftcode}
                            onChange={value => handleInputChange('Bank_Detail', { name: 'swiftcode', value: value }, index)}
                            />
                        </FlexboxGrid.Item>
                         </div>
                          ))}
                    </FlexboxGrid>
                    <Stack justifyContent='flex-end'>
                        <Button appearance='primary' color='cyan' onClick={submit}>Save</Button>
                        </Stack>
                    
                
                <Divider><b>Company Details</b></Divider>
                
                    <Table
                        rowHeight={60}
                        data={data1}
                        height={500}
                        rowKey="id"
                    >
                        <Table.Column width={60} align="center" fixed>
                            <Table.HeaderCell><b>ID</b></Table.HeaderCell>
                            <Table.Cell dataKey="id" />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Company Name</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'cmpnm']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>City</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'city']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>GST.No</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'gstno']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>FAX No.</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'faxno']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Email</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'email_id']} />
                        </Table.Column>

                        <Table.Column width={150} fixed="right">
                            <Table.HeaderCell><b>Action</b></Table.HeaderCell>

                            <Table.Cell style={{ padding: '6px',gap:"10px" }}>
                                {(rowData) => (
                                    
                                    <IconButton
                                        size="sm"
                                        icon={<TrashIcon />}
                                        active
                                        onClick={() => handleDeleteRow(rowData.id)}
                                    />
                                    
                                )}
                            </Table.Cell>
                        </Table.Column>
                    </Table>
                    </Panel>


                <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
                    <div className="container">
                        <p>© All Right Reserved. Product by </p>
                    </div>
                    <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
                </Stack>
            </Container>
        </>
    );
};

export default CompanyMaster;